import ParroquiaActions from './Actions'
import { Chip } from '@mui/material'

export const getColumns = (onEdit, onDelete, onRefresh) => [
  { field: 'id', headerName: 'ID', headerAlign: 'center', width: 70 },
  {
    field: 'nombre',
    headerName: 'Nombre',
    headerAlign: 'center',
    flex: 2,
    minWidth: 150,
  },
  {
    field: 'slug',
    headerName: 'Slug',
    headerAlign: 'center',
    flex: 1.5,
    minWidth: 120,
  },
  {
    field: 'cantonNombre',
    headerName: 'Cantón',
    headerAlign: 'center',
    flex: 1.5,
    minWidth: 120,
    valueGetter: params => {
      return params.row.cantonNombre || params.row.canton?.nombre || '-'
    },
  },
  {
    field: 'hasGeojson',
    headerName: 'GeoJSON',
    headerAlign: 'center',
    flex: 1,
    minWidth: 100,
    renderCell: params => (
      <Chip
        label={params.value ? 'Cargado' : 'Pendiente'}
        color={params.value ? 'info' : 'warning'}
        size="small"
        variant="outlined"
      />
    ),
  },
  {
    field: 'habilitado',
    headerAlign: 'center',
    headerName: 'Estado',
    flex: 1,
    minWidth: 100,
    renderCell: params => (
      <Chip
        label={params.value ? 'Activo' : 'Inactivo'}
        color={params.value ? 'success' : 'default'}
        size="small"
        variant="outlined"
      />
    ),
  },
  {
    field: 'actions',
    headerAlign: 'center',
    headerName: 'Acciones',
    type: 'actions',
    renderCell: params => (
      <ParroquiaActions {...{ params, onEdit, onDelete, onRefresh }} />
    ),
    minWidth: 150,
    flex: 1.5,
  },
]
